import { SOCIAL_NETWORKS } from './SocialLinks'
import { t } from '../i18n'

// Settings > Branding: the store's social media accounts, shown as icons in
// the header and footer of its website. Saved with the page's Save button.
export default function SocialLinksFields({ value, onChange }) {
  const links = value || {}
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl font-semibold text-gray-900">{t("Social media")}</h2>
        <p className="text-gray-600">{t("Add your accounts - they appear as icons on your website. Leave a field empty to hide it.")}</p>
      </div>
      <div className="card-body grid grid-cols-1 md:grid-cols-2 gap-4">
        {SOCIAL_NETWORKS.map(({ key, label, icon: Icon, placeholder }) => (
          <div key={key}>
            <label className="form-label flex items-center gap-2" htmlFor={`social-${key}`}><Icon size={16} aria-hidden="true" /> {t(label)}</label>
            <input
              id={`social-${key}`}
              type={key === 'whatsapp' ? 'tel' : 'text'}
              inputMode={key === 'whatsapp' ? 'tel' : 'url'}
              className="form-input"
              maxLength={300}
              value={links[key] ? (key === 'whatsapp' && /^\d+$/.test(links[key]) ? `+${links[key]}` : links[key]) : ''}
              onChange={e => onChange({ ...links, [key]: e.target.value })}
              placeholder={placeholder}
            />
          </div>
        ))}
        <p className="md:col-span-2 text-sm text-gray-500">{t("For WhatsApp, enter the number with the country code. Customers tap it to start a chat.")}</p>
      </div>
    </div>
  )
}
